import React from 'react';
import {ThemedView, ThemedText} from '@app/theme';
import Button from '@sharedComponents/Button/Button';
import BottomSheetContainer from '@sharedComponents/Bottomsheet/Bottomsheet';
import LottieView from 'lottie-react-native';

interface KYCSummarySuccessProps {
  isVisible: boolean;
  onClose: () => void;
  successLottie: any;
  handleNextNavigation: () => void;
  colors: any;
}

const KYCSummarySuccess: React.FC<KYCSummarySuccessProps> = ({
  isVisible,
  onClose,
  successLottie,
  handleNextNavigation,
  colors
}) => {
  return (
    <BottomSheetContainer
      isVisible={isVisible}
      close={onClose}
      onClose={onClose}
      dragComponent={null}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containsTextInput
      containerStyle={{backgroundColor: '#fefefe'}}
    >
      <ThemedView alignItems={"center"} padding={"lg"}>
        <LottieView source={successLottie} autoPlay={true} loop={true} style={{ width: 70, height: 70}}/>
        <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"} textAlign={"center"}>
          {"KYC done successfully!"}
        </ThemedText>
        <ThemedText variant={"b3r"} textAlign={"center"} mt={"md"} mb={"2xl"}>
          You will be redirected to next step in few seconds
        </ThemedText>
        <Button
          label="Continue"
          type="OUTLINED"
          size='MD'
          disabled={false}
          handlePress={handleNextNavigation}
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
        />
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default KYCSummarySuccess; 